import { State, process } from "@progress/kendo-data-query"
import { Button, Toolbar, ToolbarItem } from "@progress/kendo-react-buttons"
import { Grid, GridColumn, GridDataStateChangeEvent } from "@progress/kendo-react-grid"
import dayjs from "dayjs"
import {
    MDBBtn,
    MDBCol,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
} from "mdbreact"
import { useEffect, useState } from "react"
import {
    postTestPackageDetails,
    setTestPackageBookingImpactGrid,
    setTestPackageDetails,
    setTestPackageDetailsLoading,
    toggleImpactModal,
} from "../../containers/Fees/feesSlice"
import { RootState } from "../../rootReducer"
import { columnProps } from "../../shared/ActiveGridFilter"
import { SpinnerFragment } from "../../shared/CommonItems"
import { useAppDispatch, useAppSelector } from "../../store"
import { PermissionsChecker } from "../Shared/permissionChecker"

const TestPackageImpactModal = () => {
    const dispatch = useAppDispatch()
    const isImpactModal = useAppSelector((state: RootState) => state.containers.fees.impactModal)
    const selectedPackageDetails = useAppSelector((state: RootState) => state.containers.fees.testPackageDetails)
    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)
    const testPackageBookingImpactGrid = useAppSelector(
        (state: RootState) => state.containers.fees.testPackageBookingImpactGrid,
    )
    const testPackageBookingLoader = useAppSelector(
        (state: RootState) => state.containers.fees.testPackageBookingLoader,
    )
    const initialState: State = {skip: 0, take: 20}

    const [dataState, setDataState] = useState(initialState)

    useEffect(() => {
        setDataState(initialState)
    }, [testPackageBookingImpactGrid])

    return (
        <MDBModal
            className="lvl-two-popup"
            staticBackdrop
            animationDirection="right"
            show={isImpactModal}
            tabIndex="-1"
        >
            <MDBModalDialog position="top right modal-lg" side>
                <MDBModalContent className="full-height">
                    <MDBModalHeader titleClass="lead">
                        <MDBModalTitle>Impact on Future Bookings </MDBModalTitle>
                        <MDBBtn
                            color="none"
                            className="btn-close"
                            onClick={() => {
                                dispatch(toggleImpactModal(false))
                                dispatch(setTestPackageBookingImpactGrid([]))
                                dispatch(setTestPackageDetails({...selectedPackageDetails}))
                                dispatch(setTestPackageDetailsLoading(false))
                            }}
                        ></MDBBtn>
                    </MDBModalHeader>
                    <Toolbar className="shadow-0 border-bottom p-0 pb-1 pt-1  position-sticky top-0">
                        <ToolbarItem>
                            <PermissionsChecker permission={["TestPackages.Edit"]}>
                                <Button
                                    className="me-2"
                                    type="submit"
                                    fillMode="flat"
                                    themeColor={"primary"}
                                    iconClass="fa fa-check"
                                    onClick={() => {
                                        let testPackageDetails: any = {
                                            ...selectedPackageDetails,
                                            effectiveDate: dayjs(selectedPackageDetails.effectiveDate).format(
                                                "YYYY-MM-DD",
                                            ),
                                        }

                                        dispatch(
                                            postTestPackageDetails(
                                                selectedDealer?.dealerId ?? 0,
                                                testPackageDetails,
                                                true,
                                            ),
                                        )
                                    }}
                                >
                                    Accept
                                </Button>
                                <Button
                                    fillMode="flat"
                                    themeColor={"primary"}
                                    iconClass="fa fa-ban"
                                    onClick={() => {
                                        dispatch(toggleImpactModal(false))
                                        dispatch(setTestPackageDetails({...selectedPackageDetails}))
                                        dispatch(setTestPackageDetailsLoading(false))
                                        dispatch(setTestPackageBookingImpactGrid([]))
                                    }}
                                >
                                    Cancel
                                </Button>
                            </PermissionsChecker>
                        </ToolbarItem>
                    </Toolbar>
                    {testPackageBookingLoader && <SpinnerFragment />}

                    <MDBModalBody className="modal-overflow">
                        <MDBCol auto>
                            <p className="note note-primary">
                                <span>
                                    Upcoming Bookings based on{" "}
                                    {dayjs(selectedPackageDetails.effectiveDate).format("YYYY-MM-DD")} will be reflected
                                    as shown below.
                                </span>
                            </p>
                        </MDBCol>
                        <Grid
                            style={{
                                height: "calc(100vh - 12.3rem)",
                            }}
                            data={process(testPackageBookingImpactGrid, dataState)}
                            {...dataState}
                            onDataStateChange={(e: GridDataStateChangeEvent) => setDataState(e.dataState)}
                            sortable={true}
                            pageable={true}
                        >
                            <GridColumn
                                {...columnProps("bookingRef", dataState)}
                                field="bookingRef"
                                title="BK Ref"
                                width={"120px"}
                            />
                            <GridColumn
                                {...columnProps("laneFee", dataState)}
                                field="laneFee"
                                title="Lane Fee"
                                width={"120px"}
                                />
                            <GridColumn
                                {...columnProps("testFee", dataState)}
                                field="testFee"
                                title="Test Fee"
                                width={"120px"}
                                />
                            <GridColumn
                                {...columnProps("duration", dataState)}
                                field="duration"
                                title="Duration"
                                width={"120px"}
                                className={"text-end pe-5"}

                            />
                            <GridColumn
                                {...columnProps("bookingStatus", dataState)}
                                field="bookingStatusName"
                                title="Bk Status"
                                width={"120px"}
                            />
                            <GridColumn
                                {...columnProps("startDate", dataState)}
                                field="startDate"
                                title="TestStart"
                                filter={"date"}
                                format="{0:d}"
                                className={"text-end pe-5"}
                            />
                        </Grid>
                    </MDBModalBody>
                </MDBModalContent>
            </MDBModalDialog>
        </MDBModal>
    )
}

export default TestPackageImpactModal
